import { GuestAssetFolderController } from './guest-asset-folder.controller'

const component = {
  bindings: {
    folder: '<',
    assetPackId: '<',
    onSelect: '&',
    isSelected: '<?'
  },
  templateUrl: '/guest/components/guest-asset-folder/guest-asset-folder.html?$$REVISION$$',
  controller: GuestAssetFolderController,
  controllerAs: '$ctrl'
}

export const guestAssetFolder = component
